import React from "react";

const Activities = () => {
  return (
    <div className="max-w-[1140] m-auto w-full md:flex mt-[-75px] items-center justify-center">
      <div className="relative p-4">
        <h3 className="absolute z-10 top-[50%] left-[50%] translate-x-[-50%] translate-y-[-50%] text-white font-bold">
          Lorem
        </h3>
        <img
          className="w-full h-60 object-cover relative border-4 border-white shadow-lg "
          src="https://images.pexels.com/photos/1472887/pexels-photo-1472887.jpeg?auto=compress&cs=tinysrgb&w=600"
          alt="/"
        />
      </div>
      <div className="relative p-4">
        <h3 className="absolute z-10 top-[50%] left-[50%] translate-x-[-50%] translate-y-[-50%] text-white font-bold">
          Lorem
        </h3>
        <img
          className="w-full h-60 object-cover relative border-4 border-white shadow-lg"
          src="https://images.unsplash.com/photo-1586508577428-120d6b072945?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxzZWFyY2h8MTJ8fGRpdmluZ3xlbnwwfHwwfHw%3D&auto=format&fit=crop&w=500&q=600"
          alt="/"
        />
      </div>
      <div className="relative p-4">
        <h3 className="absolute z-10 top-[50%] left-[50%] translate-x-[-50%] translate-y-[-50%] text-white font-bold">
          Lorem
        </h3>
        <img
          className="w-full h-60 object-cover relative border-4 border-white shadow-lg"
          src="https://images.unsplash.com/photo-1440130266107-787dd24d69d7?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxzZWFyY2h8MjJ8fHBhcmFnbGlkZXxlbnwwfHwwfHw%3D&auto=format&fit=crop&w=500&q=600"
          alt="/"
        />
      </div>
    </div>
  );
};

export default Activities;
